import React, { useEffect, useRef, useState } from "react";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import { VALIDATE } from "../utils/Validators";
import Checkbox from "../ui/Checkbox";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { kbdEvent, playSounds } from "../utils/Utils";
import TextButton from "../ui/TextButton";
import Float from "../ui/Float";
import Button from "../ui/Button";
import Cookies from 'js-cookie';
import { drawPicker } from "../popovers/Picker";
import { tab } from "@testing-library/user-event/dist/tab";

export default function ApiSelector(props) {


    const { callback = () => { }, route = "" } = props;
    const refs = useRef([]);
    const [index, setIndex] = useState("database");

    const [tabs, setTabs] = useState([
        { key: "database", value: Cookies.get("l") || "false" },
        { key: "api", value: Cookies.get('api') || "https://devapi.bookmanager.com/" },
    ])


    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };



    // Keyboard Events
    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const options = [
            { label: "unset", value: "" },
            { label: "tbraun", value: "https://tbraunapi.bookmanager.com/" },
            { label: "eric", value: "https://ericapi.bookmanager.com/" },
            { label: "atoth", value: "https://atothapi.bookmanager.com/" },
            { label: "mike", value: "https://mikeapi.bookmanager.com/" },
            { label: "dev", value: "https://devapi.bookmanager.com/" },
            { label: "staging", value: "https://stagingapi.bookmanager.com/" },
            { label: "live", value: "https://api.bookmanager.com/" },
        ]

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.PAGE_DOWN, action: (e) => { 
                Cookies.set("l", getVal("database"));
                Cookies.set("api", getVal("api"));
                window.location.reload();
            } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            {
                key: KBD.ENTER, action: (e) => {
                    if (index === "database") {
                        let _db = getVal("database");
                        update("database", (_db === "true") ? "false" : "true")
                    } 
                }
            },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            {
                key: KBD.PAGE_UP, action: (e) => {
                    drawPicker({
                        value: "", ref: refs.current["api"], route: route, callback: (e) => {
                            update("api", e)
                        }, offset: [0, 10],
                        options: options
                    })
                }
            }
        ];
        const cleanup = listen(route, actions, (e) => { }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN], [], []);
        return cleanup;
    }, [index, update]);


    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
    });

    return (
        <>
            <div>
                <div className="shim" /> <div className="shim" />
                <Label style={{ "textAlign": "left" }} width={200}>Use live database?</Label>
                <div className="shim" />
                <Checkbox onChange={() => {
                     let _db = getVal("database");
                     update("database", (_db === "true") ? "false" : "true")
                     
                }} {...editProps("database")} value={(getVal("database") === "true")}></Checkbox>
                <div className="shim" /><div className="shim" />
                <Label style={{ "textAlign": "left" }} width={200}>API</Label>
                <div className="shim" />
                <Input doubleclick={KBD.PAGE_UP} {...editProps("api")} controlled maxLength={40} autoselect width={300} value={getVal("api")} />
                <div className="shim" /> <div className="shim" /> <div className="shim" />
                <Float>
                    <div>&nbsp;</div>
                    <Space>
                        <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)}>Cancel</Button>
                        <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} disabled type="secondary">Save</Button>
                    </Space>
                </Float>
            </div>
        </>
    )
}